import { render } from "./UserHome.vue?vue&type=template&id=6548939e&scoped=true"
import script from "./UserHome.vue?vue&type=script&lang=js"
export * from "./UserHome.vue?vue&type=script&lang=js"

import "./UserHome.vue?vue&type=style&index=0&id=6548939e&scoped=true&lang=css"

import exportComponent from "/home/forge/staging.virtualcp.app/releases/20260928150148/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6548939e"]])

export default __exports__